/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\TimeFilter\TimeFilter.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday December 20th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday December 20th 2023 11:26:31 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import BtnsGroup from "Content/BtnsGroup/BtnsGroup";
import translator from "MultiLanguage/TranslationWrapper";
import { indexOf } from "lodash-es";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { FaSortAmountUp } from "react-icons/fa";
import { ImSortAmountDesc } from "react-icons/im";

type TimeFilterProps = {
    handleUpdateFilter: Function,
    order?: string,
    orderBy?: string,
    setOrderBy?: Function,
    setOrder?: Function
}

const TimeFilter = forwardRef((props: TimeFilterProps, ref) => {
    const [dayActive, setDayActive] = useState("notActivated");
    const [weekActive, setWeekActive] = useState("desc");
    const [monthActive, setMonthActive] = useState("notActivated");
    const [yearActive, setYearActive] = useState("notActivated");
    const [curActive, setCurActive] = useState(props.orderBy);
    const [curOrder, setCurOrder] = useState(props.order);
    const btnsIdx = ["day", "week", "month", "year"];
    const [selected, setSelected] = useState<number>(1);

    useImperativeHandle(ref, () => {
        if (props.setOrder && props.setOrderBy && curActive !== "" && curOrder!== "") {
            props.setOrderBy(curActive);
            props.setOrder(curOrder);
        }
        return {
            curActive,
            curOrder
        };
    }, [curActive, curOrder]);

    useEffect(() => {
        if (props.order && props.orderBy) {
            setManageButtonStates(props.orderBy, props.order);
            if (btnsIdx.includes(props.orderBy))
                setSelected(indexOf(btnsIdx, props.orderBy));
        }
    }, []);

    // useEffect(() => {
    //     if (props.previousState) {
    //         setManageButtonStates(props.previousState?.orderby, props.previousState?.order);
    //         if (btnsIdx.includes(props.previousState.orderby)) {
    //             setSelected(indexOf(btnsIdx, props.previousState.orderby));
    //         }
    //     }
    // }, [props.previousState?.orderby, props.previousState?.order]);

    const data = [
        {
            name: "day",
            text: translator.decode("table.time.day"),
            icon: dayActive === "notActivated" ? <></> : (dayActive === "desc" ? <ImSortAmountDesc className="ms-1"/> : <FaSortAmountUp className="ms-1"/>),
            status: dayActive,
        },
        {
            name: "week",
            text: translator.decode("table.time.week"),
            icon: weekActive === "notActivated" ? <></> : (weekActive === "desc" ? <ImSortAmountDesc className="ms-1"/> : <FaSortAmountUp className="ms-1"/>),
            status: weekActive,
        },
        {
            name: "month",
            text: translator.decode("table.time.month"),
            icon: monthActive === "notActivated" ? <></> : (monthActive === "desc" ? <ImSortAmountDesc className="ms-1"/> : <FaSortAmountUp className="ms-1"/>),
            status: monthActive,
        },
        {
            name: "year",
            text: translator.decode("table.time.year"),
            icon: yearActive === "notActivated" ? <></> : (yearActive === "desc" ? <ImSortAmountDesc className="ms-1"/> : <FaSortAmountUp className="ms-1"/>),
            status: yearActive,
        },
    ];

    const operationDict = new Map();
    operationDict.set("day", {activeFunc: setDayActive, otherFunc:[setWeekActive, setMonthActive, setYearActive]});
    operationDict.set("week", {activeFunc: setWeekActive, otherFunc:[setDayActive, setMonthActive, setYearActive]});
    operationDict.set("month", {activeFunc: setMonthActive, otherFunc:[setDayActive, setWeekActive, setYearActive]});
    operationDict.set("year", {activeFunc: setYearActive, otherFunc:[setDayActive, setWeekActive, setMonthActive]});

    const setManageButtonStates = (active: string, order: string) => {
        if (operationDict.has(active)) {
            operationDict.get(active).activeFunc(order);
            operationDict.get(active).otherFunc.forEach((element: Function) => {
                element("notActivated");
            });
            if (active !== curActive || order !== curOrder) {
                setCurActive(active);
                setCurOrder(order);
            }
        }  else {
            setCurActive("");
            setCurOrder("");
            operationDict.forEach((val) => {
                val.activeFunc("notActivated");
            });
        }
    };

    const setCurrentlyActiveAndOrder = (active: string, order: string) => {
        setManageButtonStates(active, order);
        props.handleUpdateFilter({from: active, order});
    };

    return (
        <BtnsGroup ref={ref} class="d-flex justify-content-end" selected={selected} data={data} changeState={setCurrentlyActiveAndOrder} />
    )
})

export default TimeFilter;
